import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactElement } from 'react';
import { cn } from '#cn';
import { VStack } from './v-stack';
type CardPadding = 6 | 8;
const paddingClasses: Record<CardPadding, string> = {
  6: 'p-6',
  8: 'p-8'
};
type CardProps = ComponentProps<typeof VStack> & {
  padding?: CardPadding;
};

/** A rounded, surface-coloured content card — a `VStack` with padding (`6` or `8`, default `8`). */
export const Card = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      padding: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const padding = t1 === undefined ? 8 : t1;
  const t2 = paddingClasses[padding];
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("bg-surface rounded-3xl", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <VStack className={t3} {...props} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};